import { Grid2, Typography, Box, Chip } from "@mui/material"
import { memo, useMemo, useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import Table from "../components/Table"
import { stringAToZInsensitive } from "@iamnapo/sort";
import { isFuzzyMatch } from "../utils/index.js";
import { getUsersData } from "../api/index.js";
import Spinner from "../components/Spinner.js";
import PeopleIcon from '@mui/icons-material/People';
import { dateRangeFilterMethod } from "../utils/date-filter.js";

const useStyles = makeStyles((theme) => ({
	form_title: {
		color: theme.palette.primary.main,
		display: "flex",
		alignItems: "center"
	},
	form_subtitle: {
		color: theme.palette.primary.main,
		display: "flex",
		alignItems: "center",
		marginBottom: "1rem",
	},
	container: {
		width: "80%"
	},
}));

const InvitedUsers = () => {
	const classes = useStyles();
	const [users, setUsers] = useState([])
	const [isLoading, setIsLoading] = useState(false);

	const fetchInvitedUsers = async () => {
		setIsLoading(true)
		const { success: success, users } = await getUsersData()

		if (success) {
			setUsers(users)
		}
		setIsLoading(false)
	}

	useEffect(() => {
		fetchInvitedUsers();
	}, []);

	const tableColumns = useMemo(() => [
		{
			Header: <Typography id="fullname_header" variant="h8">{"Ονοματεπώνυμο"}</Typography>,
			accessor: "fullName",
			id: "fullName",
			filterable: true,
			maxWidth: 300,
			minWidth: 200,
			sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
			filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
			Cell: ({ value }) => (
				<Box sx={{ display: "flex", ml: 1, alignItems: "center", justifyContent: "center" }}>
					<Typography>
						{value}
					</Typography>
				</Box>
			),
		},
		{
			Header: <Typography id="role_header" variant="h8">{"Ρόλος"}</Typography>,
			accessor: "role",
			id: "role",
			filterable: true,
			maxWidth: 300,
			minWidth: 200,
			useDropdownFilter: true,
			sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
			filterMethod: ({ id, value }, row) => {
				return value.length === 0 || value.includes(row[id]);
			},
			Cell: ({ value }) => (
				<Box sx={{ display: "flex", ml: 1, alignItems: "center", justifyContent: "center" }}>
					<Chip
						label={value}
						sx={{
							backgroundColor: "grey.300",
							color: "black"
						}}
					/>
				</Box>
			),
		},
		{
			Header: <Typography id="username_header" variant="h8">{"Όνομα χρήστη"}</Typography>,
			accessor: "username",
			id: "username",
			filterable: true,
			maxWidth: 300,
			minWidth: 200,
			sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
			filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
			Cell: ({ value }) => (
				<Box sx={{ display: "flex", ml: 1, alignItems: "center", justifyContent: "center" }}>
					<Typography>
						{value}
					</Typography>
				</Box>
			),
		},
		{
			Header: <Typography id="email_header" variant="h8">{"Email"}</Typography>,
			accessor: "email",
			id: "email",
			filterable: true,
			maxWidth: 350,
			minWidth: 200,
			sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
			filterMethod: ({ id, value }, row) => isFuzzyMatch(row[id], value),
			Cell: ({ value }) => (
				<Box sx={{ display: "flex", ml: 1, alignItems: "center", justifyContent: "center" }}>
					<Typography>
						{value}
					</Typography>
				</Box>
			),
		},
		{
			Header: <Typography id="createdAt_header" variant="h8">{"Ημ/νια εισαγωγής"}</Typography>,
			accessor: "createdAt",
			id: "createdAt",
			filterable: true,
			maxWidth: 300,
			minWidth: 230,
			useDatePickerFilter: true,
			sortMethod: (value1, value2) => stringAToZInsensitive()(value1, value2),
			filterMethod: dateRangeFilterMethod,
			Cell: ({ value }) => (
				<Box sx={{ display: "flex", ml: 1, alignItems: "center", justifyContent: "center" }}>
					<Typography>
						{new Date(value).toLocaleDateString("el-GR")}
					</Typography>
				</Box>
			),
		},
	])
	return (
		<>
			<Spinner open={isLoading} />
			<Grid2 container className={classes.container} direction="column" sx={{ marginLeft: "3rem" }}>
				<Typography variant="h5" className={classes.form_title}><PeopleIcon sx={{ marginRight: '8px' }} />Χρήστες</Typography>
				<Typography variant="subtitle1" className={classes.form_subtitle}>Παρακάτω φαίνονται όλοι οι χρήστες της πλατφόρμας</Typography>
				<Table
					data={users}
					noDataText={"Δεν βρέθηκαν εγγραφές!"}
					columns={tableColumns}
					defaultSorted={[{ id: "name", desc: true }]}
				/>
			</Grid2>
		</>
	);
}

export default memo(InvitedUsers);